import { useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

const getId = () => uuidv4();

type UseUniqueIdOptions = {
    /**
     * префикс
     */
    prefix?: string;
    /**
     * уже имеющийся id, который надо использовать
     */
    givenId?: string;
};

/**
 * Вернуть уникальный id
 * @param optionsOrPrefix опции или префикс
 * @returns id
 */
export function useUniqueId(optionsOrPrefix?: string | UseUniqueIdOptions): string {
    const [id] = useState(getId);

    const givenId = typeof optionsOrPrefix === 'object' ? optionsOrPrefix.givenId : undefined;

    if (givenId) {
        return givenId;
    }

    const prefix = typeof optionsOrPrefix === 'object' ? optionsOrPrefix.prefix : optionsOrPrefix;

    if (prefix) {
        return `${prefix}-${id}`;
    }

    return id;
}
